import Vue from 'vue'
import VueRouter from 'vue-router'
import { trackPageView } from '@/utils/track'
import ProductsGallery from '@/views/products/Gallery.vue'
import ProductsCategories from '@/views/products/Categories.vue'
import Product from '@/views/products/Product.vue'
import OrderForm from '@/views/orders/OrderForm.vue'
import Order from '@/views/orders/Order.vue'
import { onSharedDomain, currentShop } from '@/utils/shop'

Vue.use(VueRouter)

// vue-router с 3.1 отклоняет промис перехода на текущий адрес, а витрина зовёт
// push «на всякий случай»: вкладки и категории ставят свой адрес и при открытии
// страницы, где уже стоят. Каждый такой вызов давал в консоли Uncaught
// NavigationDuplicated — глушим только его, остальные ошибки летят дальше
const push = VueRouter.prototype.push
VueRouter.prototype.push = function (this: VueRouter, location: any, onComplete?: any, onAbort?: any) {
  if (onComplete || onAbort) {
    return push.call(this, location, onComplete, onAbort)
  }
  return (push.call(this, location) as any).catch((error: any) => {
    if (!VueRouter.isNavigationFailure(error, VueRouter.NavigationFailureType.duplicated)) {
      throw error
    }
  })
} as any

// Разделы витрины. На общем домене каждый живёт под префиксом магазина, на
// домене клиента — сразу от корня, а магазин подставляется из хоста.
const pages = [
  { path: '', component: ProductsCategories },
  { path: '/c/:categoryId', component: ProductsGallery },
  { path: '/p/:productId', component: Product },
  { path: '/orders/new', component: OrderForm },
  { path: '/orders/:orderId', component: Order },
]

const routes = onSharedDomain
  ? pages.map(page => ({
      path: `/:publicUrl${page.path}`,
      component: page.component,
      props: true
    }))
  : pages.map(page => ({
      path: page.path || '/',
      component: page.component,
      props: (route: any) => ({ ...route.params, publicUrl: currentShop() })
    }))

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Заголовок страницы ставит сервер при отдаче документа — клиентом его больше
// не трогаем, иначе он затрёт и название товара, и то, что видит поисковик.
router.afterEach(to => {
  trackPageView(to.fullPath, document.title)
})

export default router
